export const WHATSAPP_RINGTONE_OPTIONS = [
  { value: 'default', label: 'Default (synthesized)' },
  { value: 'classic.mp3', label: 'Classic phone' },
  { value: 'clean.mp3', label: 'Clean' },
  { value: 'magical.mp3', label: 'Magical' },
  { value: 'normal.mp3', label: 'Normal' },
  { value: 'off', label: 'Off (silent)' },
];

const RINGTONE_FILES = {
  'classic.mp3': '/ringtones/soynoviembre-classic-phone-ringtone-439034.mp3',
  'clean.mp3': '/ringtones/soundreality-phone-ringtone-clean-273554.mp3',
  'magical.mp3': '/ringtones/soundreality-phone-ringtone-magical-273558.mp3',
  'normal.mp3': '/ringtones/soundreality-phone-ringtone-normal-444775.mp3',
};

class Ringer {
  constructor() {
    this.ctx = null;
    this.intervalId = null;
    this.audioEl = null;
  }

  start(choice = 'default') {
    if (this.intervalId || this.audioEl) return;
    if (choice === 'off') return;

    if (RINGTONE_FILES[choice]) {
      this._startMp3(RINGTONE_FILES[choice]);
    } else {
      this._startSynth();
    }
  }

  _startMp3(path) {
    try {
      this.audioEl = new Audio(path);
      this.audioEl.loop = true;
      this.audioEl.volume = 0.7;
      this.audioEl.play().catch(() => { /* autoplay blocked, ignore */ });
    } catch (_) {
      this.audioEl = null;
    }
  }

  _startSynth() {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    try {
      this.ctx = new Ctx();
    } catch (_) {
      this.ctx = null;
      return;
    }

    const playRing = () => {
      const ctx = this.ctx;
      if (!ctx) return;
      const now = ctx.currentTime;
      const duration = 1.6;

      [440, 480].forEach(freq => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.frequency.value = freq;
        osc.type = 'sine';
        gain.gain.setValueAtTime(0, now);
        gain.gain.linearRampToValueAtTime(0.12, now + 0.05);
        gain.gain.setValueAtTime(0.12, now + duration - 0.08);
        gain.gain.linearRampToValueAtTime(0, now + duration);
        osc.connect(gain).connect(ctx.destination);
        osc.start(now);
        osc.stop(now + duration + 0.05);
      });
    };

    playRing();
    this.intervalId = setInterval(playRing, 3200);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.ctx) {
      try { this.ctx.close(); } catch (_) { /* noop */ }
      this.ctx = null;
    }
    if (this.audioEl) {
      try { this.audioEl.pause(); this.audioEl.src = ''; } catch (_) { /* noop */ }
      this.audioEl = null;
    }
  }
}

export const whatsappRinger = new Ringer();
